import { Component, h, Host, Prop } from '@stencil/core'

@Component({
    tag: 'zr-loyalty-points-badge',
    styleUrl: 'zr-loyalty-points-badge.scss',
    shadow: true,
})

/**
 * The zooroyal points card.
 */
export class ZrLoyaltyPointsBadge {
    /**
     * Amount of points user have.
     */
    @Prop() points: number

    /**
     * Points Text.
     */
    @Prop() text = 'Punkte'

    /**
     * Renders the component.
     */
    render() {
        return (
            <Host>
                <div class='zr-loyalty-points-badge'>
                    {this.points?.toLocaleString()} {this.text}
                </div>
            </Host>
        )
    }
}
